module.exports = __webpack_public_path__ + "img/teacher.23230a9f.png";